import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { pushImpression } from '../../utils/data-layer';
import { convertDataLayerPayload, extractListingDataLayerData } from '../../utils/transformers';

const snakeToDashCase = str => str.replace(/_/g, '-');

const EcommerceImpression = ({ contacts, currentLocation, listName, promotionType, yachtData }) => {
  const payload = extractListingDataLayerData({ ...yachtData, promotionType }, contacts, listName);

  useEffect(() => {
    pushImpression(payload);
  }, [currentLocation]);

  const dataIzedPayload = {
    className: 'gtm-ecommerce-click'
  };
  const convertedPayload = convertDataLayerPayload(payload);
  Object.keys(convertedPayload).forEach(
    key => (dataIzedPayload[`data-${snakeToDashCase(key)}`] = convertedPayload[key])
  );

  return <span style={{ display: 'none' }} {...dataIzedPayload} />;
};

EcommerceImpression.propTypes = {
  contacts: PropTypes.array.isRequired,
  currentLocation: PropTypes.string.isRequired,
  listName: PropTypes.string.isRequired,
  promotionType: PropTypes.string.isRequired,
  yachtData: PropTypes.object.isRequired
};

export default EcommerceImpression;
